import { Validators } from '@angular/forms';
// import { Field } from '@praceprofirmy/ppf-ui-forms';

export enum DocumentCategory {
  INVENTORY = 'INVENTORY',
  TRADE_DOCUMENTS = 'TRADE_DOCUMENTS',
  FOCUS = 'FOCUS',
  VISUALIZATION = 'VISUALIZATION',
  TECHNICAL_DOCUMENTS = 'TECHNICAL_DOCUMENTS',
  ELECTRO_INSTALATION = 'ELECTRO_INSTALATION',
  FOTODOCUMENTATION = 'FOTODOCUMENTATION',
  OTHER = 'OTHER',
}

// Re-export GraphQL OrderDocumentCategory for compatibility
export { OrderDocumentCategory } from '../gql/types.g';

export const DOCUMENT_FORM_MODULE: any[] = [
  {
    name: 'documentsName',
    label: 'Název',
    visible: true,
    type: 'INPUT',
  },
  {
    name: 'category',
    label: 'Kategorie',
    type: 'SELECT',
    visible: true,
    disabled: false,
    validators: [Validators.required],
    options: [
      {
        key: DocumentCategory.VISUALIZATION,
        value: 'Vizualizace',
      },
      {
        key: DocumentCategory.TECHNICAL_DOCUMENTS,
        value: 'Technické dokumenty',
      },
      {
        key: DocumentCategory.FOTODOCUMENTATION,
        value: 'Fotodokumentace',
      },
    ],
  },
  {
    name: 'documents',
    label: 'Dokumenty',
    type: 'FILE',
    visible: true,
    disabled: false,
    multiple: true,
  },
];
